import ajaxRequest from 'utils/_ajax-request.js'

/**
 * @param {string} rowSelector
 * @param {string} openUrl
 * @param {Function} callback
 */
let onRowButtonClick = (rowSelector, openUrl, callback) =>
  /**
   * @param {Event} event
   */
  (event) => {
    let rowElement = event.target.closest(rowSelector)
    if (rowElement && rowElement.dataset.id) {
      ajaxRequest(
        (xhr, error) => {
          if( error ) {
            return false
          }
          let pageAjax = document.getElementById('page-ajax')
          pageAjax.innerHTML = xhr.responseText
          pageAjax.classList.remove('-is-hidden')
          callback(xhr)
        },
        (openUrl+'?ajax=1')
          .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
          .replaceAll('{!id}', rowElement.dataset.id)
        //(openUrl+'?ajax=1').replace(/{!_locale}/g, (document.documentElement.lang || 'en')).replace(/{!id}/g, rowElement.dataset.id)
      )
    } else {
      console.warn('No id')
    }
  }

/**
 * @param {HTMLElement} rowButton
 * @param {string} rowSelector
 * @param {string} openUrl
 * @param {Function} callback
 */
export default (
  rowButton,
  rowSelector,
  openUrl,
  callback = () => {},
) => {
  rowButton.addEventListener('click', onRowButtonClick(rowSelector, openUrl, callback))
}
